import { useState, useCallback } from 'react';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration/index.js';

/**
 * @typedef {Object} MessageData
 * @property {string} id
 * @property {string[]} params
 * @property {string} message
 */

/**
 * @typedef {Object} Client
 * @property {string} name
 * @property {string} phone
 */

/**
 * @typedef {Object} SendActiveMultipleTextProtocol
 * @property {string} usrSocketId
 * @property {MessageData} messageData
 * @property {string} queue
 * @property {string} channelId
 * @property {string} userLogin
 * @property {Client[]} clients
 * @property {(err: any) => void} onError - um callback a ser executado em caso de erro na solicitação
 * @property {(res: any) => void} onSuccess - um callback a ser executado em caso de solicitação bem sucedida
 *
 * @example
 * {
 *   "usrSocketId": "pZ7zfJsIih3SunWqAAZj",
 *   "messageData": {
 *     "id": "4995ab10-167a-4693-9663-0b4eb8506c8d",
 *     "params": [
 *       "leandro",
 *       "a g4!"
 *     ],
 *     "message": "Olá leandro, Seja bem vindo a g4!."
 *   },
 *   "queue": "Suporte",
 *   "channelId": "2ee733da-9c5f-4eb3-9523-c8a927873316",
 *   "userLogin": "leandro.felix",
 *   "clients": [
 *     {
 *       "name": "Leandro Felix",
 *       "phone": "8892285712"
 *     },
 *     {
 *       "name": "Caio",
 *       "phone": "88993552505"
 *     }
 *   ]
 * }
 */

/**
 * Permite o envio de ativos individuais de texto via Whatsapp para múltiplos contatos simultaneamente.
 */
export function useSendActiveMultipleText() {
  const [state, setState] = useState({
    isPending: false,
    result: null,
    error: null
  });

  const sendActiveMultipleText = useCallback(
    /** @param {SendActiveMultipleTextProtocol} props */
    async ({ onError, onSuccess, ...props }) => {
      setState({ isPending: true, result: null, error: null });

      try {
        const res = await FlexChatIntegration.sendActiveMultipleText(props);
        setState({ isPending: false, result: res, error: null });
        onSuccess(res);
      } catch (err) {
        setState({ isPending: false, result: null, error: err });
        onError(err);
      }
    },
    []
  );

  return {
    ...state,
    sendActiveMultipleText
  };
}
